import React, { FC } from 'react';

export const Sezzle: FC<{ className?: string }> = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 86 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.4585 14.3767C3.40335 16.3104 6.55605 16.3104 8.50091 14.3767L8.68731 14.1914C9.6592 13.2251 7.71434 8.15575 8.68731 7.18945L1.4585 14.3767Z"
      fill="url(#paint0_linear_728_5671)"
    />
    <path
      d="M8.87468 7.00316L8.68827 7.18849C7.71639 8.15479 9.66016 13.2241 8.68827 14.1904L15.9171 7.00316C14.9441 6.03686 13.6705 5.55371 12.3959 5.55371C11.1212 5.55264 9.84657 6.03686 8.87468 7.00316"
      fill="url(#paint1_linear_728_5671)"
    />
    <path
      d="M1.45864 7.37471C-0.486213 9.30838 -0.486213 12.443 1.45864 14.3766L8.87601 7.00191C10.8209 5.06824 10.8209 1.93367 8.87601 0L1.45864 7.37471Z"
      fill="url(#paint2_linear_728_5671)"
    />
    <path
      d="M8.50112 14.3767C6.55627 16.3103 6.55627 19.4449 8.50112 21.3786L15.9185 14.0039C17.8633 12.0702 17.8633 8.93562 15.9185 7.00195L8.50112 14.3767Z"
      fill="url(#paint3_linear_728_5671)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.1085 9.28215C44.4005 9.73102 44.6236 10.2185 44.7733 10.7284C44.9188 11.2244 44.6322 11.7461 44.1333 11.8918L36.3033 14.1747C36.6384 14.7296 37.1092 15.1828 37.6727 15.4881C38.5272 15.9509 39.54 16.0591 40.4688 15.7881C40.8933 15.6638 41.2855 15.471 41.6325 15.2138C41.6486 15.1946 41.6799 15.1667 41.7122 15.141C42.0893 14.8453 42.3996 14.4832 42.6334 14.0676C42.8005 13.7698 43.1172 13.5855 43.461 13.5855C43.6226 13.5855 43.782 13.6273 43.9232 13.7055C44.379 13.9594 44.5427 14.5347 44.2874 14.9878C44.1441 15.2438 43.9792 15.4892 43.796 15.7184L43.7508 15.7741C43.0343 16.6504 42.0861 17.2739 40.9989 17.59C40.485 17.741 39.9559 17.8171 39.4258 17.8171C38.5035 17.8171 37.5844 17.5825 36.7676 17.1379C35.6115 16.5101 34.8185 15.6691 34.3455 14.5679C34.3422 14.5614 34.1903 14.1586 34.0955 13.8437L34.0912 13.8298C33.6785 12.4157 33.8423 10.9266 34.5513 9.63353C35.2646 8.33407 36.4423 7.39134 37.8688 6.97782C39.2814 6.56859 40.8168 6.7325 42.1023 7.4299C42.9168 7.87342 43.6096 8.51404 44.1085 9.28215ZM41.1961 9.07661C40.653 8.78308 40.0464 8.62774 39.4408 8.62774C39.0928 8.62774 38.7426 8.67809 38.4 8.77772C37.4583 9.05304 36.6814 9.67546 36.2116 10.5314C35.8992 11.1003 35.744 11.7366 35.7612 12.3762L42.5785 10.3879C42.5651 10.3659 42.5511 10.344 42.5374 10.3224C42.5323 10.3145 42.5273 10.3067 42.5224 10.2989C42.1906 9.79008 41.7316 9.36693 41.1961 9.07661Z"
      fill="#382757"
    />
    <path
      d="M54.8232 16.0271H49.6427L55.4363 7.56613C55.5462 7.40651 55.5569 7.20082 55.4664 7.02942C55.3759 6.85801 55.1981 6.75195 55.0031 6.75195H47.6375C47.1483 6.75195 46.7507 7.14726 46.7507 7.63362C46.7507 8.11998 47.1483 8.51529 47.6375 8.51529H52.5734L46.7819 16.9763C46.672 17.137 46.6613 17.3427 46.7518 17.513C46.8423 17.6844 47.0201 17.7894 47.2151 17.7894H54.8221C55.3113 17.7894 55.7089 17.3941 55.7089 16.9077C55.7099 16.4235 55.3124 16.0271 54.8232 16.0271Z"
      fill="#382757"
    />
    <path
      d="M66.3003 16.027H61.1208L66.9133 7.56603C67.0232 7.40641 67.034 7.20073 66.9435 7.02932C66.853 6.85899 66.6752 6.75293 66.4802 6.75293H59.1156C58.6264 6.75293 58.2289 7.14823 58.2289 7.6346C58.2289 8.12096 58.6264 8.51626 59.1156 8.51626H64.0516L58.2601 16.9773C58.1513 17.1379 58.1394 17.3436 58.2299 17.514C58.3215 17.6854 58.4982 17.7904 58.6932 17.7904H66.3003C66.7894 17.7904 67.187 17.3951 67.187 16.9087C67.187 16.4234 66.7894 16.027 66.3003 16.027Z"
      fill="#382757"
    />
    <path
      d="M71.4151 1.97852C70.9259 1.97852 70.5283 2.37382 70.5283 2.86018V16.9401C70.5283 17.4264 70.9259 17.8217 71.4151 17.8217C71.9043 17.8217 72.3019 17.4253 72.3019 16.9401V2.86018C72.3019 2.37382 71.9043 1.97852 71.4151 1.97852Z"
      fill="#382757"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.2984 9.28313C85.5893 9.73307 85.8135 10.2194 85.9621 10.7294C86.1076 11.2243 85.821 11.746 85.3221 11.8917L77.491 14.1768C77.825 14.7317 78.297 15.1848 78.8605 15.4901C79.7149 15.9529 80.7288 16.0611 81.6565 15.7901C82.0821 15.6658 82.4743 15.473 82.8213 15.2159C82.8385 15.1966 82.8687 15.1688 82.9021 15.143C83.2781 14.8474 83.5885 14.4864 83.8223 14.0696C83.9893 13.7718 84.3061 13.5875 84.6498 13.5875C84.8114 13.5875 84.9709 13.6293 85.112 13.7075C85.5678 13.9614 85.7316 14.5367 85.4762 14.9899C85.334 15.2427 85.1691 15.488 84.986 15.7183L84.9396 15.7772C84.2242 16.6525 83.276 17.276 82.1888 17.592C81.6749 17.7431 81.1447 17.8191 80.6157 17.8191C79.6934 17.8191 78.7743 17.5845 77.9576 17.1399C76.8014 16.5111 76.0084 15.6712 75.5354 14.5699C75.5321 14.5624 75.3802 14.1596 75.2854 13.8457L75.2811 13.8307C74.8695 12.4166 75.0322 10.9265 75.7423 9.63451C76.4545 8.33504 77.6322 7.39231 79.0587 6.9788C80.4724 6.56957 82.0056 6.73348 83.2922 7.43088C84.1057 7.87439 84.7995 8.51502 85.2984 9.28313ZM82.386 9.07616C81.843 8.78263 81.2363 8.6273 80.6308 8.6273C80.2817 8.6273 79.9315 8.67765 79.5899 8.77727C78.6482 9.05259 77.8714 9.67501 77.4016 10.531C77.0891 11.0998 76.934 11.7351 76.9512 12.3757L83.7684 10.3874C83.755 10.3655 83.741 10.3435 83.7273 10.322C83.7223 10.3141 83.7173 10.3063 83.7124 10.2985C83.3794 9.78964 82.9215 9.36648 82.386 9.07616Z"
      fill="#382757"
    />
    <path
      d="M31.1206 12.8892C30.8577 12.5067 30.4773 12.1875 29.9925 11.9411C29.1983 11.5394 28.1694 11.3551 27.1824 11.2019L27.0262 11.1783C26.3333 11.0712 25.6168 10.9598 25.1567 10.7284C24.8087 10.5527 24.6848 10.3556 24.6848 9.971C24.6848 9.22646 25.5004 8.66511 26.5812 8.66511C27.872 8.66511 28.5917 9.04005 29.3998 9.52963C29.5496 9.62069 29.722 9.6689 29.8966 9.6689C30.2327 9.6689 30.5377 9.49963 30.7133 9.21467C30.8458 8.99827 30.8868 8.74331 30.8264 8.49584C30.7661 8.24945 30.6131 8.04055 30.3954 7.90878C29.9483 7.63667 29.4591 7.35385 28.8417 7.13317C28.1467 6.8857 27.4076 6.76465 26.5822 6.76465C25.5866 6.76465 24.6546 7.06568 23.9596 7.61203C23.1957 8.21195 22.7744 9.0497 22.7744 9.971C22.7744 11.0744 23.3002 11.9229 24.2947 12.4232C25.0253 12.7906 25.8937 12.9245 26.7331 13.0542L26.8882 13.0777C29.041 13.413 29.6638 13.7151 29.6638 14.4233C29.6638 15.3006 28.7803 15.8748 27.413 15.8866H27.3634C25.8959 15.8866 25.0727 15.3263 24.6309 15.0253C24.5576 14.976 24.4951 14.9321 24.4327 14.8935C24.2807 14.7993 24.1062 14.75 23.9273 14.75C23.5955 14.75 23.2916 14.9171 23.116 15.1967C22.8369 15.6413 22.9737 16.2284 23.4209 16.5058C23.4457 16.5208 23.4834 16.5465 23.5254 16.5755L23.5513 16.5926C24.076 16.9493 25.3043 17.7871 27.3634 17.7871H27.4291C28.6165 17.7764 29.6358 17.4593 30.3793 16.8679C31.1497 16.2541 31.5742 15.3863 31.5742 14.4243C31.5731 13.8405 31.4201 13.3252 31.1206 12.8892Z"
      fill="#382757"
    />
    <defs>
      <linearGradient
        id="paint0_linear_728_5671"
        x1="10.081"
        y1="12.575"
        x2="6.08377"
        y2="8.99526"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CE5DCB" />
        <stop
          offset="0.2095"
          stopColor="#C558CC"
        />
        <stop
          offset="0.5525"
          stopColor="#AC4ACF"
        />
        <stop
          offset="0.9845"
          stopColor="#8534D4"
        />
        <stop
          offset="1"
          stopColor="#8333D4"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_728_5671"
        x1="8.40762"
        y1="14.1899"
        x2="15.9169"
        y2="14.1899"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.0237"
          stopColor="#FF5667"
        />
        <stop
          offset="0.6592"
          stopColor="#FC8B82"
        />
        <stop
          offset="1"
          stopColor="#FBA28E"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_728_5671"
        x1="-0.00026937"
        y1="14.3768"
        x2="10.3346"
        y2="14.3768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B874" />
        <stop
          offset="0.5126"
          stopColor="#29D3A2"
        />
        <stop
          offset="0.6817"
          stopColor="#53DFB6"
        />
        <stop
          offset="1"
          stopColor="#9FF4D9"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_728_5671"
        x1="7.04219"
        y1="21.3786"
        x2="17.377"
        y2="21.3786"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCD77E" />
        <stop
          offset="0.5241"
          stopColor="#FEA500"
        />
        <stop
          offset="1"
          stopColor="#FF5B00"
        />
      </linearGradient>
    </defs>
  </svg>
);
